import { render, staticRenderFns } from "./loc_full_cards_desc.vue?vue&type=template&id=93975176&scoped=true&"
import script from "./loc_full_cards_desc.vue?vue&type=script&lang=js&"
export * from "./loc_full_cards_desc.vue?vue&type=script&lang=js&"
import style0 from "./loc_full_cards_desc.vue?vue&type=style&index=0&id=93975176&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93975176",
  null
  
)

export default component.exports